import { API } from "api";

export const getFnstrListAPI = (req) => {
    return API.get("api/functionalstructure/getall?page=0&size=0")
        .then((res) => res);
};

export const getFnstrALLExportAPI = (payload) => {
    return API.get("api/functionalstructure/exportall?page=1&size=1000").then((res) => res);
};

